import { SVGProps } from 'react';

const SmileyKindUnhappy = (props: SVGProps<SVGSVGElement>) => (
    <svg width={24} height={24} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M12 23C18.0751 23 23 18.0751 23 12C23 5.92487 18.0751 1 12 1C5.92487 1 1 5.92487 1 12C1 18.0751 5.92487 23 12 23Z"
            stroke="var(--bloko-icon-color, var(--bloko-icon-color-default))"
            strokeWidth={2}
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M12 18C13.1399 15.7025 15.4833 14.2495 18.048 14.25"
            stroke="var(--bloko-icon-color, var(--bloko-icon-color-default))"
            strokeWidth={2}
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M14.375 8C14.5821 8 14.75 8.16789 14.75 8.375C14.75 8.58211 14.5821 8.75 14.375 8.75C14.1679 8.75 14 8.58211 14 8.375C14 8.16789 14.1679 8 14.375 8"
            stroke="var(--bloko-icon-color, var(--bloko-icon-color-default))"
            strokeWidth={2}
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M8.5 7.875C8.70711 7.875 8.875 8.04289 8.875 8.25C8.875 8.45711 8.70711 8.625 8.5 8.625C8.29289 8.625 8.125 8.45711 8.125 8.25C8.125 8.04289 8.29289 7.875 8.5 7.875"
            stroke="var(--bloko-icon-color, var(--bloko-icon-color-default))"
            strokeWidth={2}
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </svg>
);
export default SmileyKindUnhappy;
